import { BaseService } from '../../../../../core/services/base.service';
import {
  JobSkillsSuggestionRequest,
  JobSkillsSuggestionResponse,
} from '../models/job-skills-suggestion.model';

export class JobSkillsSuggestionService {
  static Suggest(
    request: JobSkillsSuggestionRequest,
    CallbackCatch?: (error: Error) => void
  ): Promise<JobSkillsSuggestionResponse> {
    return BaseService.Post(
      '/featured/jobs/skills-suggestions',
      request,
      undefined,
      CallbackCatch,
      false
    );
  }
}
